import React, { Component } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import HeaderDashBoard from "../img/marketingPage/Depositphotos_31419439_xl-2015.png";
import "./overview.css";
import "../dashcore/html/css/aos.css";
import "../dashcore/html/css/bootstrap.css";
import "../dashcore/html/css/cookieconsent.min.css";
import "../dashcore/html/css/fontawesome-all.css";
import "../dashcore/html/css/helper.css";
import "../dashcore/html/css/magnific-popup.css";
import "../dashcore/html/css/odometer-theme-minimal.css";
import "../dashcore/html/css/pe-icon-7-stroke.css";
import "../dashcore/html/css/prettify.css";
import "../dashcore/html/css/simplebar.css";
import "../dashcore/html/css/smart_wizard.css";
import "../dashcore/html/css/smart_wizard_theme_arrows.css";
import "../dashcore/html/css/smart_wizard_theme_circles.css";
import "../dashcore/html/css/smart_wizard_theme_dots.css";
import "../dashcore/html/css/demo.css";
import "../dashcore/html/css/swiper.css";
import "../dashcore/html/css/styles.css";
import ThreeDModelImg from "../img/marketingPage/3d-model.png";
import StoreImg from "../img/marketingPage/store.png";
import MergeImg from "../img/marketingPage/merge.png";
import SuperiorPrecision from "../img/marketingPage/computer1.png";
import Interoperability from "../img/marketingPage/computer2.png";
import ViewshedAnalysis from "../img/marketingPage/icon_viewshed.png";
import SlopeAnalysis from "../img/marketingPage/icon_slope.png";
import DistanceAnalysis from "../img/marketingPage/icon_distance.png";
import ContourAnalysis from "../img/marketingPage/icon_contour.png";
import FloodAnalysis from "../img/marketingPage/icon_flood.png";
import ShadowAnalysis from "../img/marketingPage/icon_shadow.png";
import VolumeAnalysis from "../img/marketingPage/icon_volume.png";
import ComparisonAnalysis from "../img/marketingPage/icon_comparison.png";
import MapImage from "../img/marketingPage/map_production.png";
import LayersImage from "../img/marketingPage/layers.png";
import PublishingToSecureImage from "../img/marketingPage/publishing_to_secure.png";
import Avatar1 from "../dashcore/html/img/avatar/1.jpg";
import OrangeFlag from "../img/marketingPage/flag_orange_small.png";
import BlueFlag from "../img/marketingPage/flag_blue_small.png";

class LosAngeles extends Component {
  constructor(props) {
    super(props);

    this.state = { isTop: true };
    AOS.init();
    this.props.props.setHeaderClassName(true, this.state.isTop);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, false);
  }

  componentWillUnmount() {
    this.props.props.setHeaderClassName(false, this.state.isTop);
    window.removeEventListener("scroll", this.onScroll, false);
  }

  onScroll = () => {
    const isTop = window.scrollY < 100;
    if (isTop !== this.state.isTop) {
      this.setState({ isTop });
      this.props.props.setHeaderClassName(true, isTop);
    }
  };

  state = {};
  render() {
    return (
      <div className="overviewDiv">
        <header className="header online-payment-header section color-1 alpha-8">
          <div id="stripes">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <div className="container overflow-hidden bring-to-front">
            <div className="row">
              <div className="col-md-6 SLAtlasMainTitle">
                <h1 className="color-1 bold">Skyline Atlas Los Angeles</h1>
                <p className="lead col-md-8" style={{ paddingLeft: "0px" }}>
                  High Resolution 3D Map Data Service for Los Angeles metro area
                </p>
                <nav className="nav mt-5">
                  <Link
                    to="/atlasUs/Pricing"
                    className="nav-link btn btn-rounded btn-success mainTitleTryBtn"
                  >
                    7-day free trial
                  </Link>
                </nav>
              </div>
              <div className="col-md-6">
                <img
                  style={{ width: "80%", marginTop: "2.5rem" }}
                  src={HeaderDashBoard}
                  className="img-hero img-responsive absolute-md"
                  alt=""
                />
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
        </header>
        <section id="features" className="section bg-1 edge top-left" />
        <section id="features" className="tableSection section">
          <div className="tableSectionDiv container shadow">
            <div className="row gap-y mt-5 mb-5 pt-4 pb-4 text-center text-md-center">
              <div className="col-md-4 py-4 rounded shadow-hover overviewVl">
                <img src={ThreeDModelImg} />
                <h5 className="bold">Stunning Visualizations</h5>
                <p className="">
                  Online access to ready-to-use, high resolution, 2D and 3D
                  models of major US cities
                </p>
              </div>
              <div className="col-md-4 py-4 rounded shadow-hover overviewVl">
                <img src={MergeImg} />
                <h5 className="bold">Inform and Empower </h5>
                <p className="">
                  Merge Atlas data with your own proprietary data to provide
                  powerful location intelligence
                </p>
              </div>
              <div className="col-md-4 py-4 rounded shadow-hover">
                <img src={StoreImg} />
                <h5 className="bold">Store and Secure</h5>
                <p className="">
                  Store masses of 3D geospatial data for end users in a secure,
                  access-controlled environment
                </p>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
        </section>

        <section className="section edge">
          <div className="shape-wrapper">
            <div className="shape shape-background shape-right" />
            <div className="shape shape-background top shape-left bg-4 op-1" />
          </div>
          <div className="container pb-9">
            <div className="row gap-y align-items-center py-5">
              <div className="col-md-6">
                <figure data-aos="fade-right" data-aos-duration="1000">
                  <img
                    src={SuperiorPrecision}
                    className="img-responsive w-80"
                    alt=""
                  />
                </figure>
              </div>
              <div className="col-md-6">
                <h2 className="bold text-capitalize textBulletsSections">
                  Superior Precision
                </h2>
                <p className="regular textBulletsParagraph">
                  Online access to ready-to-use, high resolution, 3D models of
                  major US cities
                </p>
                <ul className="listClass textBulletsUL">
                  <li className="">World-class TerraExplorer 3D viewers</li>
                  <li className="">Support for third-party viewers</li>
                  <li className="">New cities added monthly</li>
                  <li className="">Regular data updates</li>
                  <li className="">Accurate, geo-referenced maps</li>
                </ul>
                <Link
                  to="/atlasUs/pricing#pricingHeader"
                  className="btn gradient gradient-43 color-1 btn-rounded btn-outline-1 bw-2 bold mt-4"
                >
                  7-day free trial
                </Link>
              </div>
            </div>
            <div className="row gap-y align-items-center py-5">
              <div className="col-md-6 order-md-2">
                <figure data-aos="fade-left" data-aos-duration="1000">
                  <img
                    src={Interoperability}
                    className="img-responsive w-80"
                    alt=""
                  />
                </figure>
              </div>
              <div className="col-md-6">
                <h2 className="bold text-capitalize textBulletsSections">
                  Interoperability
                </h2>
                <p className="regular textBulletsParagraph">
                  Data is available in a range of formats for compatibility with
                  a vast number of CAD and 3D solutions
                </p>
                <ul className="listClass textBulletsUL">
                  <li className="">Skyline 3DML</li>
                  <li className="">Cesium 3D Tile</li>
                  <li className="">Esri i3S</li>
                  <li className="">True-Orthophotos</li>
                </ul>
                <Link
                  to="/atlasUs/pricing#pricingHeader"
                  className="btn gradient gradient-43 color-1 btn-rounded btn-outline-1 bw-2 bold mt-4"
                >
                  7-day free trial
                </Link>
              </div>
            </div>
          </div>
          <div className="container pb-9">
            <div className="section-heading mb-6 text-center">
              <h2 className="pb-3">Powerful Analysis</h2>
              <h5 className="">
                Increase understanding and improve decision making with a wide
                range of versatile and configurable analysis tools that provide
                precise, actionable data:
              </h5>
            </div>
            <div
              align="center"
              className="row gap-y text-left text-md-left tableSection"
            >
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-9 mb-3 shadow shadow-hover tableSectionDiv analysisFirstCard">
                <img src={ViewshedAnalysis} className="img-responsive" />
                <h6 className="mt-3">Viewshed</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={DistanceAnalysis} className="img-responsive" />
                <h6 className="mt-3">Distance</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={FloodAnalysis} className="img-responsive" />
                <h6 className="mt-3">Flood</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={VolumeAnalysis} className="img-responsive" />
                <h6 className="mt-3">Volume</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-9 mb-3 shadow shadow-hover tableSectionDiv analysisFirstCard">
                <img src={SlopeAnalysis} className="img-responsive" />
                <h6 className="mt-3">Slope</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={ContourAnalysis} className="img-responsive" />
                <h6 className="mt-3">Contour</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={ShadowAnalysis} className="img-responsive" />
                <h6 className="mt-3">Shadow</h6>
              </div>
              <div className="col-md-2 col-xs-3 col-3 px-md-5 ml-4 mb-3 shadow shadow-hover tableSectionDiv">
                <img src={ComparisonAnalysis} className="img-responsive" />
                <h6 className="mt-3">Comparison</h6>
              </div>
            </div>
          </div>
        </section>
        <section
          id="features"
          className="section CustomizedSection parallax image-background center-bottom cover overlay gradient gradient-53 alpha-8 color-1"
        >
          <div className="container overflow-hidden">
            <div className="row">
              <div className="col-md-10 col-lg-5">
                <span className="titleCaption">Customized Maps</span>
                <br />
                <br />
                <span className="paragraphClass">
                  Integrate Skyline Atlas data with your own proprietary data to
                  create immersible, high-resolution 3D maps that promote deeper
                  understanding
                </span>

                <div className="row analysisClass">
                  <div className="col-md-9 col-sm-5 customizeMapDiv">
                    <img
                      // className={className}
                      src={LayersImage}
                      // style={{ transitionDelay: leftTransitionDelay }}
                    />
                    <p
                      className="paragraphClass customizeMapParagraph"
                      // style={{ transitionDelay: leftTransitionDelay }}
                    >
                      Add annotations, models & layers to base map
                      <br />
                      {/* <Link to="/gettingStarted#publishDataSection" className="">
                        Learn more >
                      </Link> */}
                    </p>
                  </div>
                </div>
                <div className="row analysisClass">
                  <div className="col-md-9 col-sm-5 customizeMapDiv">
                    <img
                      // className={className}
                      src={PublishingToSecureImage}
                      // style={{ transitionDelay: leftTransitionDelay }}
                    />
                    <p
                      className="paragraphClass customizeMapParagraph"
                      // style={{ transitionDelay: leftTransitionDelay }}
                    >
                      Publishing to secure, access-controlled server
                      <br />
                      {/* <Link to="/gettingStarted#publishDataSection" className="">
                        Learn more >
                      </Link> */}
                    </p>
                  </div>
                </div>

                <p className="handwritten font-md highlight px-4">
                  Try it free
                </p>
                <nav className="nav mt-5">
                  <Link
                    to="/atlasUs/pricing#pricingHeader"
                    className="nav-link mr-3 btn btn-rounded btn-success mainTitleTryBtn"
                  >
                    Try Now{" "}
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </section>
        <section className="section bg-6 edge send-and-receive">
          <div className="container bring-to-front">
            <div className="container pb-2">
              <div className="section-heading text-center">
                <h2 className="pb-3">Affordable and Scalable</h2>
                <h5 className="">
                  Flexible subscription packages to suit your specific user and
                  storage needs
                </h5>
              </div>
            </div>
            <div className="row gap-y">
              <div className="col-md-4">
                <div className="rounded bg-1 shadow-box image-background contain bottom-background pl-md-9 p-4 pl-6  scale_upClass">
                  <p className="color-2 mt-3 ml-4">
                    Scale up as your business grows
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="rounded bg-1 shadow-box image-background contain bottom-background  pl-md-9 p-4 pl-6  quarterlyClass"
                  style={{
                    backgroundImage: "url(img / shps / payments / get.svg)"
                  }}
                >
                  <p className="color-2 mt-3 ml-4">
                    Scale up/down quarterly (seasonal business)
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="rounded bg-1 shadow-box image-background contain bottom-background  p-4 pl-6 pl-md-9 subscriptionClass"
                  style={{
                    backgroundImage: "url(img / shps / payments / get.svg)"
                  }}
                >
                  <p className="color-2 mt-3 ml-4">
                    Subscription plans as low as $100/month
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default LosAngeles;
